import { render } from "./SelfEmploymentForm.vue?vue&type=template&id=796534ee&scoped=true"
import script from "./SelfEmploymentForm.vue?vue&type=script&lang=js"
export * from "./SelfEmploymentForm.vue?vue&type=script&lang=js"

import "./SelfEmploymentForm.vue?vue&type=style&index=0&id=796534ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796534ee"]])

export default __exports__